import { FileIconType } from './types'

/** Returns the lowercase file extension (without dot) from a filename or empty string */
export const getFileExtension = (filename?: string): string => {
  if (!filename) return ''
  const lastDot = filename.lastIndexOf('.')
  if (lastDot <= 0 || lastDot === filename.length - 1) return ''
  return filename.substring(lastDot + 1).toLowerCase()
}

export const mapExtensionToIconType = (ext?: string): FileIconType => {
  const e = (ext || '').toLowerCase()
  if (!e) return 'generic'
  if (['pdf'].includes(e)) return 'pdf'
  if (
    [
      'jpg',
      'jpeg',
      'png',
      'gif',
      'webp',
      'bmp',
      'svg',
      'heic',
      'tiff',
    ].includes(e)
  ) {
    return 'image'
  }
  if (['xls', 'xlsx', 'csv', 'ods', 'tsv'].includes(e)) {
    return 'table'
  }
  if (['txt', 'md', 'rtf', 'doc', 'docx', 'odt', 'pages'].includes(e)) {
    return 'text'
  }
  return 'generic'
}

export const mapContentTypeToIconType = (
  contentType?: string,
): FileIconType => {
  const ct = (contentType || '').trim().toLowerCase()
  if (!ct) return 'generic'

  if (ct.startsWith('image/')) return 'image'
  if (ct.startsWith('text/')) return 'text'

  if (ct === 'application/pdf') return 'pdf'

  // Spreadsheets
  if (
    [
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.oasis.opendocument.spreadsheet',
      'text/csv',
      'text/tab-separated-values',
    ].includes(ct)
  ) {
    return 'table'
  }

  // Documents
  if (
    [
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/vnd.oasis.opendocument.text',
      'application/rtf',
    ].includes(ct)
  ) {
    return 'text'
  }

  return 'generic'
}

export const iconNameForType = (type: FileIconType): string => {
  switch (type) {
    case 'pdf':
      return 'pdf'
    case 'image':
      return 'image'
    case 'table':
      return 'table'
    case 'text':
      return 'document-text'
    default:
      return 'file-empty'
  }
}

export const extensionFromContentType = (contentType?: string): string => {
  const ct = (contentType || '').trim().toLowerCase()
  if (!ct) return ''

  if (ct === 'application/pdf') return 'pdf'

  if (
    ct === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  ) {
    return 'xlsx'
  }
  if (ct === 'application/vnd.ms-excel') return 'xls'
  if (ct === 'text/csv') return 'csv'

  if (
    ct ===
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
  ) {
    return 'docx'
  }
  if (ct === 'application/msword') return 'doc'
  if (ct === 'application/rtf') return 'rtf'
  if (ct === 'text/plain') return 'txt'

  if (ct.startsWith('image/')) {
    const subtype = ct.slice('image/'.length)
    if (subtype === 'jpeg') return 'jpg'
    return subtype
  }

  if (ct.startsWith('video/')) {
    return ct.slice('video/'.length)
  }

  if (ct.startsWith('audio/')) {
    return ct.slice('audio/'.length)
  }

  return ''
}
